/*
 * OPP-0091: search results page enhancements.
 *  - Spell-correction notice: the results page heading shows the raw query, but
 *    Shopify may have served results for a corrected term. Liquid cannot see
 *    Shopify's native correction; the theme's own brand-typo map (in
 *    predictive-search.js) can, so we reuse the live <predictive-search>
 *    element's normalizeQuery() at runtime rather than duplicating the map.
 *  - Suggestion chips: Shopify's query suggestions give broad OR-grids a way to
 *    narrow without opening the filter drawer.
 * Runs only on a performed search that returned results.
 */
(function () {
  var heading = document.querySelector('.cc-search-heading[data-search-terms]');
  if (!heading) return;
  var raw = (heading.getAttribute('data-search-terms') || '').trim();
  if (!raw) return;

  // --- Spell-correction notice ---------------------------------------------
  function showCorrection() {
    var el = heading.querySelector('[data-search-correction]');
    if (!el) return;
    var ps = document.querySelector('predictive-search');
    if (!ps || typeof ps.normalizeQuery !== 'function') return;
    var corrected;
    try { corrected = ps.normalizeQuery(raw); } catch (e) { return; }
    // normalizeQuery lowercases and collapses whitespace; only announce when a
    // token actually changed (a real typo fix), not a case/spacing difference.
    var baseline = raw.toLowerCase().replace(/\s+/g, ' ').trim();
    if (!corrected || corrected === baseline) return;
    var label = el.getAttribute('data-label') || 'Showing results for';
    el.textContent = label + ' ';
    var strong = document.createElement('strong');
    strong.textContent = corrected;
    el.appendChild(strong);
    el.hidden = false;
  }

  // --- Suggestion chips -----------------------------------------------------
  function showSuggestions() {
    var wrap = heading.querySelector('[data-search-suggestions]');
    if (!wrap) return;
    var url = '/search/suggest.json?q=' + encodeURIComponent(raw) +
      '&resources[type]=query&resources[limit]=8';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var results = (data && data.resources && data.resources.results &&
          data.resources.results.queries) || [];
        var rawLc = raw.toLowerCase();
        var seen = {};
        var chips = [];
        results.forEach(function (q) {
          var text = ((q && q.text) || '').trim();
          var key = text.toLowerCase();
          if (!text || key === rawLc || seen[key]) return;
          seen[key] = true;
          chips.push(text);
        });
        chips = chips.slice(0, 6);
        if (!chips.length) return;
        // Match the predictive dropdown's quick-link group: a small heading with
        // a single horizontally-scrollable row of chips beneath it.
        var label = wrap.getAttribute('data-label');
        if (label) {
          var h = document.createElement('h2');
          h.className = 'predictive-search__quick-group-title font-bold';
          h.textContent = label;
          wrap.appendChild(h);
        }
        var ul = document.createElement('ul');
        ul.className = 'predictive-search__quick-list';
        ul.setAttribute('role', 'list');
        chips.forEach(function (text) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.className = 'predictive-search__quick-link';
          a.href = '/search?q=' + encodeURIComponent(text) + '&options[prefix]=last';
          a.textContent = text;
          li.appendChild(a);
          ul.appendChild(li);
        });
        wrap.appendChild(ul);
        wrap.hidden = false;
      })
      .catch(function () { /* best effort: leave the chips hidden */ });
  }

  showCorrection();
  showSuggestions();
})();
